import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "block"
  }, [_c('div', [_c('Previewer', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    ref: "previewer",
    attrs: {
      "list": _vm.picList,
      "options": _vm.options
    }
  })], 1), _vm._l(_vm.extFields, function (extField, i) {
    return [[1, 2, 3, 4, 5, 6, 8, 9, 12, 13, 18].indexOf(extField.type) !== -1 || extField.type === null ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name font-size-h3-normal"
    }, [_vm._v(" " + _vm._s(extField.name) + " ")]), _c('div', {
      staticClass: "line-value font-size-h3-normal"
    }, [_c('pre', {
      staticStyle: {
        "white-space": "pre-line",
        "word-break": "break-all"
      }
    }, [_vm._v("            " + _vm._s(extField.value || '-') + "\n        ")])])]) : [17].indexOf(extField.type) !== -1 ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(i18n.tc("342"))]), _c('div', {
      staticClass: "line-value"
    }, [_c('a', {
      staticClass: "main-color",
      attrs: {
        "target": "_blank",
        "href": _vm.spliteHyperLink(extField.name)[0]
      }
    }, [_vm._v(" " + _vm._s(_vm.spliteHyperLink(extField.name)[1]) + " ")])])]) : [7, 16].indexOf(extField.type) !== -1 ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name font-size-h3-normal"
    }, [_vm._v(" " + _vm._s(extField.name) + " ")]), _c('div', {
      staticClass: "line-value font-size-h3-normal"
    }, [_vm._v(" " + _vm._s(extField.value === '1' ? i18n.tc("86") : i18n.tc("87") || '-') + " ")])]) : [10, 26].indexOf(extField.type) !== -1 && _vm.imgViewType === 0 ? [_c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name font-size-h3-normal"
    }, [_vm._v(" " + _vm._s(extField.name) + " ")]), _c('div', {
      staticClass: "line-value font-size-h3-normal"
    }, [_vm._v(" " + _vm._s(extField.value ? '' : '-') + " ")])]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: extField.value != null && extField.value !== '',
        expression: "extField.value != null && extField.value !== ''"
      }],
      staticClass: "img"
    }, _vm._l(extField.value.split(','), function (pic, index) {
      return _c('img', {
        key: index,
        attrs: {
          "src": pic
        },
        on: {
          "click": function ($event) {
            return _vm.imgClick(extField, index);
          }
        }
      });
    }), 0)] : [10, 26].indexOf(extField.type) !== -1 && _vm.imgViewType === 1 ? [_c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name font-size-h3-normal"
    }, [_vm._v(" " + _vm._s(extField.name) + " ")]), extField.value != null && extField.value !== '' ? _c('div', {
      staticClass: "line-value font-size-h3-normal img"
    }, _vm._l(extField.value.split(','), function (pic, index) {
      return _c('img', {
        key: index,
        attrs: {
          "src": pic
        },
        on: {
          "click": function ($event) {
            return _vm.imgClick(extField, index);
          }
        }
      });
    }), 0) : _c('div', {
      staticClass: "line-value font-size-h3-normal"
    }, [_vm._v("-")])])] : [11].indexOf(extField.type) !== -1 ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name font-size-h3-normal"
    }, [_vm._v(" " + _vm._s(extField.name) + " ")]), _c('div', {
      staticClass: "line-value font-size-h3-normal"
    }, [_vm._v(" " + _vm._s(extField.value ? extField.value.split(',')[0] : '-') + " ")])]) : [14].indexOf(extField.type) !== -1 ? [_c('div', {
      key: i,
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-value"
    }, [_vm._v(_vm._s(extField.name || '-'))])]), _c('div', {
      key: i + '-img',
      staticClass: "item-bubble-img instruction-img"
    }, [_c('photo-provider', _vm._l(extField.fieldAttributeList || [], function (image, i) {
      return _c('photo-consumer', {
        key: i,
        attrs: {
          "intro": _vm.$showName(image.value),
          "src": image.value
        }
      }, [_c('img', {
        staticClass: "previewer-demo-img item-bubble-img-i",
        attrs: {
          "src": image.value
        }
      })]);
    }), 1)], 1)] : [15].indexOf(extField.type) !== -1 ? [extField.value ? _vm._l(extField.value.split(','), function (item, index) {
      return _c('div', {
        staticClass: "line"
      }, [_c('div', {
        staticClass: "line-name font-size-h3-normal"
      }, [_vm._v(" " + _vm._s(index === 0 ? extField.name : '') + " ")]), _c('div', {
        staticClass: "line-value font-size-h3-normal"
      }, [_c('div', {
        staticClass: "file",
        style: {
          background: item ? '#F2F2F2' : '#FFF'
        }
      }, [_c('div', {
        staticClass: "file-name"
      }, [_c('img', {
        staticClass: "img",
        attrs: {
          "src": "/spa_static_mobile/icon/zip89_87@3x.png"
        }
      }), _c('span', [_vm._v(_vm._s(_vm.translate(item.split('/')[item.split('/').length - 1])))])]), _c('a', {
        staticClass: "download",
        attrs: {
          "href": item,
          "download": ""
        }
      }, [_vm._v(i18n.tc("103"))])])])]);
    }) : [_c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name font-size-h3-normal"
    }, [_vm._v(" " + _vm._s(extField.name) + " ")]), _c('div', {
      staticClass: "line-value font-size-h3-normal"
    }, [_vm._v("-")])])]] : [19].indexOf(extField.type) !== -1 ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(_vm._s(extField.name))]), _c('div', {
      staticClass: "line-value"
    }, [_vm._v(_vm._s(_vm.calcValue(extField)))])]) : [20].indexOf(extField.type) !== -1 ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(_vm._s(extField.name))]), _c('div', {
      staticClass: "line-value main-color"
    }, [_c('a', {
      staticClass: "main-color",
      attrs: {
        "href": "tel:" + extField.value
      }
    }, [_vm._v(" " + _vm._s(extField.value) + " ")]), _c('img', {
      staticClass: "customer-icon",
      attrs: {
        "src": require("@/assets/icon/tel24_24@3x.png")
      }
    })])]) : [21].indexOf(extField.type) !== -1 ? [_c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(_vm._s(extField.name))]), extField.realPic ? _c('div', {
      staticClass: "line-value img"
    }, [_c('img', {
      attrs: {
        "src": extField.realPic
      },
      on: {
        "click": function ($event) {
          return _vm.signClick(extField.realPic, 0);
        }
      }
    })]) : _c('div', {
      staticClass: "line-value"
    }, [_vm._v("-")])])] : [22].indexOf(extField.type) !== -1 ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(_vm._s(extField.name))]), _c('div', {
      staticClass: "line-value"
    }, [_c('Rater', {
      attrs: {
        "disabled": true,
        "value": Number(extField.value) || 0,
        "active-color": "#ffb84d",
        "margin": 5,
        "font-size": 20
      }
    })], 1)]) : _vm._e()];
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };